'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function append() {
  var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [str, suffix].join('');
  };
}

exports.default = append;
//# sourceMappingURL=append.js.map
